// This file is the home for the decorator changes we've made to the template cache provider.
//  * Support case insensitive template urls
//  * log on templateCache misses, as we expect these to indicate potential caching bugs due to our bundling scheme.

import { LoggingService } from "../sdServices/loggingSvc";
import { ServiceDeskConfig } from "./serviceDeskConfig";

export let registerTemplateCacheDecorator = ($provide: ng.auto.IProvideService) => {
  // Make the templateCacheProvider case insensitive, and alert to misses.
  $provide.decorator("$templateCache", [
    "$delegate",
    "$injector",
    "loggingService",
    "sdConfig",
    (
      $delegate: any,
      $injector: ng.auto.IInjectorService,
      loggingService: LoggingService,
      sdConfig: ServiceDeskConfig
    ) => {
      let normalGet = $delegate.get;
      let normalPut = $delegate.put;
      let alreadyMessaged: { [key: string]: boolean } = {};
      $delegate.get = function (key: string) {
        let attemptKey = (key: string) => {
          key = key ? key.toLowerCase() : key;
          return normalGet(key);
        };

        let template = attemptKey(key);
        // As we're migrating to a new index.html, we need to support different source paths for the bundled HTML.
        if (!template && key.startsWith("../")) {
          template = attemptKey(key.replace("../", "./"));
        }

        const templateSuffix = ".html";
        if (!template && sdConfig.isBundled && !alreadyMessaged[key] && key && key.endsWith(templateSuffix)) {
          loggingService.logError(
            `The template ${key} could not be found locally, and will be looked up remotely. This is likely a potential caching bug, and should be investigated.`,
            "TemplateNotFound"
          );
          alreadyMessaged[key] = true;
        }

        return template;
      };
      $delegate.put = function (key: any, value: any) {
        normalPut(key ? key.toLowerCase() : key, value);
      };

      return $delegate;
    }
  ]);
};
